// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `1653905423743.jce'
// **********************************************************************
import { Taf } from '@huyafed/taf-network';

var HUYAVIDEO = HUYAVIDEO || {};


HUYAVIDEO.InvokeCode = 
{
    success: 0,
    paramLose: 1,
    paramInvalid: 2,
    objNotExist: 3,
    objAlreadyExist: 4,
    sysError: 5,
    loadingData: 6
};


HUYAVIDEO.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sUserIp = "";
};
HUYAVIDEO.UserId.prototype._clone = function () { return new HUYAVIDEO.UserId(); }
HUYAVIDEO.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sUserIp);
};

HUYAVIDEO.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sUserIp= is.readString(6, false, this.sUserIp);
};

HUYAVIDEO.VideoStreamInfo = function()
{
    this.sSize = "";
    this.sWidth = "";
    this.sHeight = "";
    this.sFormat = "";
    this.sUrl = "";
    this.sM3u8 = "";
    this.sTs1Url = "";
    this.sTs1Offset = "";
    this.iBitrate = 0;
    this.codec = "";
    this.extParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYAVIDEO.VideoStreamInfo.prototype._clone = function () { return new HUYAVIDEO.VideoStreamInfo(); }
HUYAVIDEO.VideoStreamInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoStreamInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoStreamInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSize);
    os.writeString(1, this.sWidth);
    os.writeString(2, this.sHeight);
    os.writeString(3, this.sFormat);
    os.writeString(4, this.sUrl);
    os.writeString(5, this.sM3u8);
    os.writeString(6, this.sTs1Url);
    os.writeString(7, this.sTs1Offset);
    os.writeInt32(8, this.iBitrate);
    os.writeString(9, this.codec);
    os.writeMap(10, this.extParam);
};

HUYAVIDEO.VideoStreamInfo.prototype.readFrom = function (is)
{
    this.sSize= is.readString(0, false, this.sSize);
    this.sWidth= is.readString(1, false, this.sWidth);
    this.sHeight= is.readString(2, false, this.sHeight);
    this.sFormat= is.readString(3, false, this.sFormat);
    this.sUrl= is.readString(4, false, this.sUrl);
    this.sM3u8= is.readString(5, false, this.sM3u8);
    this.sTs1Url= is.readString(6, false, this.sTs1Url);
    this.sTs1Offset= is.readString(7, false, this.sTs1Offset);
    this.iBitrate= is.readInt32(8, false, this.iBitrate);
    this.codec= is.readString(9, false, this.codec);
    this.extParam= is.readMap(10, false, this.extParam);
};

HUYAVIDEO.VideoReqHeader = function()
{
    this.userId = new HUYAVIDEO.UserId();
    this.byPass = "default";
};
HUYAVIDEO.VideoReqHeader.prototype._clone = function () { return new HUYAVIDEO.VideoReqHeader(); }
HUYAVIDEO.VideoReqHeader.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoReqHeader.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoReqHeader.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.userId);
    os.writeString(1, this.byPass);
};

HUYAVIDEO.VideoReqHeader.prototype.readFrom = function (is)
{
    this.userId= is.readStruct(0, false, this.userId);
    this.byPass= is.readString(1, false, this.byPass);
};

HUYAVIDEO.VideoUserInfo = function()
{
    this.uid = 0;
    this.userNick = "";
    this.avatar = "";
    this.homepage = "";
    this.isOnline = true;
    this.lastLiveTime = 0;
    this.roomId = 0;
};
HUYAVIDEO.VideoUserInfo.prototype._clone = function () { return new HUYAVIDEO.VideoUserInfo(); }
HUYAVIDEO.VideoUserInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoUserInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoUserInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.uid);
    os.writeString(1, this.userNick);
    os.writeString(2, this.avatar);
    os.writeString(3, this.homepage);
    os.writeBoolean(4, this.isOnline);
    os.writeInt64(5, this.lastLiveTime);
    os.writeInt64(6, this.roomId);
};

HUYAVIDEO.VideoUserInfo.prototype.readFrom = function (is)
{
    this.uid= is.readInt64(0, false, this.uid);
    this.userNick= is.readString(1, false, this.userNick);
    this.avatar= is.readString(2, false, this.avatar);
    this.homepage= is.readString(3, false, this.homepage);
    this.isOnline= is.readBoolean(4, false, this.isOnline);
    this.lastLiveTime= is.readInt64(5, false, this.lastLiveTime);
    this.roomId= is.readInt64(6, false, this.roomId);
};

HUYAVIDEO.VideoTopic = function()
{
    this.id = 0;
    this.title = "";
    this.cover = "";
    this.intro = "";
    this.status = 0;
    this.videoNum = 0;
    this.lastVid = 0;
    this.lastVideoTitle = "";
    this.uids = new Taf.Vector(new Taf.INT64());
    this.shortTitle = "";
    this.weight = 0;
};
HUYAVIDEO.VideoTopic.prototype._clone = function () { return new HUYAVIDEO.VideoTopic(); }
HUYAVIDEO.VideoTopic.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoTopic.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoTopic.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.id);
    os.writeString(1, this.title);
    os.writeString(2, this.cover);
    os.writeString(3, this.intro);
    os.writeInt32(4, this.status);
    os.writeInt32(5, this.videoNum);
    os.writeInt64(6, this.lastVid);
    os.writeString(7, this.lastVideoTitle);
    os.writeVector(8, this.uids);
    os.writeString(9, this.shortTitle);
    os.writeInt32(10, this.weight);
};

HUYAVIDEO.VideoTopic.prototype.readFrom = function (is)
{
    this.id= is.readInt32(0, false, this.id);
    this.title= is.readString(1, false, this.title);
    this.cover= is.readString(2, false, this.cover);
    this.intro= is.readString(3, false, this.intro);
    this.status= is.readInt32(4, false, this.status);
    this.videoNum= is.readInt32(5, false, this.videoNum);
    this.lastVid= is.readInt64(6, false, this.lastVid);
    this.lastVideoTitle= is.readString(7, false, this.lastVideoTitle);
    this.uids= is.readVector(8, false, this.uids);
    this.shortTitle= is.readString(9, false, this.shortTitle);
    this.weight= is.readInt32(10, false, this.weight);
};

HUYAVIDEO.VideoDefinitionInfo = function()
{
    this.sSize = "";
    this.sWidth = "";
    this.sHeight = "";
    this.sDefinition = "";
    this.sUrl = "";
    this.sM3u8 = "";
    this.sDefName = "";
    this.sDuration = "";
    this.sFormat = "";
    this.sTs1Url = "";
    this.sTs1Offset = "";
    this.iLine = 0;
    this.iBitrate = 0;
    this.extParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.streams = new Taf.Vector(new HUYAVIDEO.VideoStreamInfo());
    this.codec = "";
};
HUYAVIDEO.VideoDefinitionInfo.prototype._clone = function () { return new HUYAVIDEO.VideoDefinitionInfo(); }
HUYAVIDEO.VideoDefinitionInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoDefinitionInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoDefinitionInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSize);
    os.writeString(1, this.sWidth);
    os.writeString(2, this.sHeight);
    os.writeString(3, this.sDefinition);
    os.writeString(4, this.sUrl);
    os.writeString(5, this.sM3u8);
    os.writeString(6, this.sDefName);
    os.writeString(7, this.sDuration);
    os.writeString(8, this.sFormat);
    os.writeString(9, this.sTs1Url);
    os.writeString(10, this.sTs1Offset);
    os.writeInt32(11, this.iLine);
    os.writeInt32(12, this.iBitrate);
    os.writeMap(13, this.extParam);
    os.writeVector(14, this.streams);
    os.writeString(15, this.codec);
};

HUYAVIDEO.VideoDefinitionInfo.prototype.readFrom = function (is)
{
    this.sSize= is.readString(0, false, this.sSize);
    this.sWidth= is.readString(1, false, this.sWidth);
    this.sHeight= is.readString(2, false, this.sHeight);
    this.sDefinition= is.readString(3, false, this.sDefinition);
    this.sUrl= is.readString(4, false, this.sUrl);
    this.sM3u8= is.readString(5, false, this.sM3u8);
    this.sDefName= is.readString(6, false, this.sDefName);
    this.sDuration= is.readString(7, false, this.sDuration);
    this.sFormat= is.readString(8, false, this.sFormat);
    this.sTs1Url= is.readString(9, false, this.sTs1Url);
    this.sTs1Offset= is.readString(10, false, this.sTs1Offset);
    this.iLine= is.readInt32(11, false, this.iLine);
    this.iBitrate= is.readInt32(12, false, this.iBitrate);
    this.extParam= is.readMap(13, false, this.extParam);
    this.streams= is.readVector(14, false, this.streams);
    this.codec= is.readString(15, false, this.codec);
};

HUYAVIDEO.VideoCover = function()
{
    this.cover = "";
    this.cover320 = "";
    this.cover375 = "";
    this.cover640 = "";
    this.tuijianCover = "";
    this.originCover = "";
    this.firstFrameCover = "";
};
HUYAVIDEO.VideoCover.prototype._clone = function () { return new HUYAVIDEO.VideoCover(); }
HUYAVIDEO.VideoCover.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoCover.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoCover.prototype.writeTo = function (os)
{
    os.writeString(0, this.cover);
    os.writeString(1, this.cover320);
    os.writeString(2, this.cover375);
    os.writeString(3, this.cover640);
    os.writeString(4, this.tuijianCover);
    os.writeString(5, this.originCover);
    os.writeString(6, this.firstFrameCover);
};

HUYAVIDEO.VideoCover.prototype.readFrom = function (is)
{
    this.cover= is.readString(0, false, this.cover);
    this.cover320= is.readString(1, false, this.cover320);
    this.cover375= is.readString(2, false, this.cover375);
    this.cover640= is.readString(3, false, this.cover640);
    this.tuijianCover= is.readString(4, false, this.tuijianCover);
    this.originCover= is.readString(5, false, this.originCover);
    this.firstFrameCover= is.readString(6, false, this.firstFrameCover);
};

HUYAVIDEO.VideoRespHeader = function()
{
    this.reqHeader = new HUYAVIDEO.VideoReqHeader();
    this.code = 0;
    this.msg = "";
};
HUYAVIDEO.VideoRespHeader.prototype._clone = function () { return new HUYAVIDEO.VideoRespHeader(); }
HUYAVIDEO.VideoRespHeader.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoRespHeader.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoRespHeader.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.reqHeader);
    os.writeInt32(1, this.code);
    os.writeString(2, this.msg);
};

HUYAVIDEO.VideoRespHeader.prototype.readFrom = function (is)
{
    this.reqHeader= is.readStruct(0, false, this.reqHeader);
    this.code= is.readInt32(1, false, this.code);
    this.msg= is.readString(2, false, this.msg);
};

HUYAVIDEO.VideoData = function()
{
    this.vid = 0;
    this.liveId = "";
    this.videoTitle = "";
    this.brief = "";
    this.sourceClient = 0;
    this.channelId = "";
    this.videoType = 0;
    this.uploadStartTime = 0;
    this.uploadEndTime = 0;
    this.covers = new HUYAVIDEO.VideoCover();
    this.tags = "";
    this.playNums = 0;
    this.favorNums = 0;
    this.shareNums = 0;
    this.commentNums = 0;
    this.danmuNums = 0;
    this.videoUrl = "";
    this.duration = "";
    this.updateTime = 0;
    this.userInfo = new HUYAVIDEO.VideoUserInfo();
    this.videoDefinitions = new Taf.Vector(new HUYAVIDEO.VideoDefinitionInfo());
    this.sourceClientName = "";
    this.channelName = "";
    this.videoTypeName = "";
    this.rawDuration = 0;
    this.topics = new Taf.Vector(new HUYAVIDEO.VideoTopic());
    this.implicitTags = "";
    this.templateId = 0;
    this.canPlay = 0;
    this.status = 0;
};
HUYAVIDEO.VideoData.prototype._clone = function () { return new HUYAVIDEO.VideoData(); }
HUYAVIDEO.VideoData.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoData.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoData.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.vid);
    os.writeString(1, this.liveId);
    os.writeString(2, this.videoTitle);
    os.writeString(3, this.brief);
    os.writeInt32(4, this.sourceClient);
    os.writeString(5, this.channelId);
    os.writeInt32(6, this.videoType);
    os.writeInt64(7, this.uploadStartTime);
    os.writeInt64(8, this.uploadEndTime);
    os.writeStruct(9, this.covers);
    os.writeString(10, this.tags);
    os.writeInt64(11, this.playNums);
    os.writeInt64(12, this.favorNums);
    os.writeInt64(13, this.shareNums);
    os.writeInt64(14, this.commentNums);
    os.writeInt64(15, this.danmuNums);
    os.writeString(16, this.videoUrl);
    os.writeString(17, this.duration);
    os.writeInt64(18, this.updateTime);
    os.writeStruct(19, this.userInfo);
    os.writeVector(20, this.videoDefinitions);
    os.writeString(21, this.sourceClientName);
    os.writeString(22, this.channelName);
    os.writeString(23, this.videoTypeName);
    os.writeFloat(24, this.rawDuration);
    os.writeVector(25, this.topics);
    os.writeString(26, this.implicitTags);
    os.writeInt64(27, this.templateId);
    os.writeInt32(28, this.canPlay);
    os.writeInt32(29, this.status);
};

HUYAVIDEO.VideoData.prototype.readFrom = function (is)
{
    this.vid= is.readInt64(0, false, this.vid);
    this.liveId= is.readString(1, false, this.liveId);
    this.videoTitle= is.readString(2, false, this.videoTitle);
    this.brief= is.readString(3, false, this.brief);
    this.sourceClient= is.readInt32(4, false, this.sourceClient);
    this.channelId= is.readString(5, false, this.channelId);
    this.videoType= is.readInt32(6, false, this.videoType);
    this.uploadStartTime= is.readInt64(7, false, this.uploadStartTime);
    this.uploadEndTime= is.readInt64(8, false, this.uploadEndTime);
    this.covers= is.readStruct(9, false, this.covers);
    this.tags= is.readString(10, false, this.tags);
    this.playNums= is.readInt64(11, false, this.playNums);
    this.favorNums= is.readInt64(12, false, this.favorNums);
    this.shareNums= is.readInt64(13, false, this.shareNums);
    this.commentNums= is.readInt64(14, false, this.commentNums);
    this.danmuNums= is.readInt64(15, false, this.danmuNums);
    this.videoUrl= is.readString(16, false, this.videoUrl);
    this.duration= is.readString(17, false, this.duration);
    this.updateTime= is.readInt64(18, false, this.updateTime);
    this.userInfo= is.readStruct(19, false, this.userInfo);
    this.videoDefinitions= is.readVector(20, false, this.videoDefinitions);
    this.sourceClientName= is.readString(21, false, this.sourceClientName);
    this.channelName= is.readString(22, false, this.channelName);
    this.videoTypeName= is.readString(23, false, this.videoTypeName);
    this.rawDuration= is.readFloat(24, false, this.rawDuration);
    this.topics= is.readVector(25, false, this.topics);
    this.implicitTags= is.readString(26, false, this.implicitTags);
    this.templateId= is.readInt64(27, false, this.templateId);
    this.canPlay= is.readInt32(28, false, this.canPlay);
    this.status= is.readInt32(29, false, this.status);
};

HUYAVIDEO.VideoTranscodeUrlRsp = function()
{
    this.respHeader = new HUYAVIDEO.VideoRespHeader();
    this.transcodeInfos = new Taf.Map(new Taf.INT64(), new HUYAVIDEO.VideoData());
};
HUYAVIDEO.VideoTranscodeUrlRsp.prototype._clone = function () { return new HUYAVIDEO.VideoTranscodeUrlRsp(); }
HUYAVIDEO.VideoTranscodeUrlRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoTranscodeUrlRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoTranscodeUrlRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.respHeader);
    os.writeMap(1, this.transcodeInfos);
};

HUYAVIDEO.VideoTranscodeUrlRsp.prototype.readFrom = function (is)
{
    this.respHeader= is.readStruct(0, false, this.respHeader);
    this.transcodeInfos= is.readMap(1, false, this.transcodeInfos);
};

HUYAVIDEO.VideoTranscodeUrlReq = function()
{
    this.reqHeader = new HUYAVIDEO.VideoReqHeader();
    this.vids = new Taf.Vector(new Taf.INT64());
    this.format = "";
    this.order = "";
    this.freeFlowFlag = 0;
    this.original = 0;
    this.domain = "";
    this.replayMp4 = true;
    this.videoIsModerated = 1;
    this.cdnDispatchFlag = 0;
};
HUYAVIDEO.VideoTranscodeUrlReq.prototype._clone = function () { return new HUYAVIDEO.VideoTranscodeUrlReq(); }
HUYAVIDEO.VideoTranscodeUrlReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoTranscodeUrlReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoTranscodeUrlReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.reqHeader);
    os.writeVector(1, this.vids);
    os.writeString(2, this.format);
    os.writeString(3, this.order);
    os.writeInt32(4, this.freeFlowFlag);
    os.writeInt32(5, this.original);
    os.writeString(6, this.domain);
    os.writeBoolean(7, this.replayMp4);
    os.writeInt32(8, this.videoIsModerated);
    os.writeInt32(9, this.cdnDispatchFlag);
};

HUYAVIDEO.VideoTranscodeUrlReq.prototype.readFrom = function (is)
{
    this.reqHeader= is.readStruct(0, false, this.reqHeader);
    this.vids= is.readVector(1, false, this.vids);
    this.format= is.readString(2, false, this.format);
    this.order= is.readString(3, false, this.order);
    this.freeFlowFlag= is.readInt32(4, false, this.freeFlowFlag);
    this.original= is.readInt32(5, false, this.original);
    this.domain= is.readString(6, false, this.domain);
    this.replayMp4= is.readBoolean(7, false, this.replayMp4);
    this.videoIsModerated= is.readInt32(8, false, this.videoIsModerated);
    this.cdnDispatchFlag= is.readInt32(9, false, this.cdnDispatchFlag);
};

export default HUYAVIDEO;